(() => {
  if (window.__alphaHomeSearchInjectReady) return;
  window.__alphaHomeSearchInjectReady = true;

  const isHome = () => {
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    return path === '/' || /^\/[a-z]{2}(-[a-z]{2})?$/i.test(path);
  };

  if (!isHome()) return;

  const labels = document.documentElement.lang?.toLowerCase().startsWith('fr')
    ? {
        kicker: 'Recherche guidée',
        title: 'Trouver le tableau idéal',
        text: 'Cherchez par artiste, style, couleur, format ou ambiance.',
        placeholder: 'Monet, Van Gogh, paysage, portrait...',
        search: 'Rechercher',
        clear: 'Effacer',
        close: 'Fermer la recherche',
        loading: 'Recherche en cours...',
        empty: 'Aucun résultat trouvé. Essayez un artiste, un style ou une collection.',
        query: 'Résultats pour',
        all: 'Tout afficher',
        products: 'Produits',
        collections: 'Collections',
        articles: 'Articles de blog',
        pages: 'Pages',
        result: 'résultat',
        results: 'résultats',
        collection: 'Collection',
        article: 'Article',
        page: 'Page',
        available: 'Disponible',
        unavailable: 'Indisponible',
        knownProducts: 'Peintures connues',
        knownCollections: 'Collections incontournables',
        loadingSuggestions: 'Chargement des œuvres et collections incontournables...',
      }
    : {
        kicker: 'Guided search',
        title: 'Find the right painting',
        text: 'Search by artist, style, subject, color or format.',
        placeholder: 'Van Gogh, Monet, landscape, portrait...',
        search: 'Search',
        clear: 'Clear',
        close: 'Close search',
        loading: 'Searching...',
        empty: 'No result found. Try an artist, style or collection.',
        query: 'Results for',
        all: 'View all',
        products: 'Products',
        collections: 'Collections',
        articles: 'Blog articles',
        pages: 'Pages',
        result: 'result',
        results: 'results',
        collection: 'Collection',
        article: 'Article',
        page: 'Page',
        available: 'Available',
        unavailable: 'Unavailable',
        knownProducts: 'Famous paintings',
        knownCollections: 'Essential collections',
        loadingSuggestions: 'Loading famous paintings and essential collections...',
      };

  const css = `
    .ahsi{background:transparent;color:#ffffff;padding:24px 0 0;position:relative;z-index:90}
    .ahsi__inner{margin:0;max-width:760px;position:relative;width:min(100%,760px)}
    .ahsi__intro{display:none}
    .ahsi__kicker{color:#c94a24;font-size:12px;font-weight:850;letter-spacing:.14em;line-height:1;margin:0 0 10px;text-transform:uppercase}
    .ahsi__title{color:inherit;font-size:clamp(30px,4vw,54px);letter-spacing:-.035em;line-height:1;margin:0}
    .ahsi__text{color:#665f55;font-size:15px;line-height:1.55;margin:0}
    .ahsi__search{display:grid;grid-template-columns:minmax(0,1fr) auto;position:relative}
    .ahsi__search.is-search-open{background:#f6f0e6;border:1px solid #ded2c3;border-radius:10px 10px 0 0;box-shadow:0 22px 54px rgba(16,16,16,.26);grid-template-columns:minmax(0,1fr) auto auto;margin:0;max-width:760px;position:relative;width:min(100%,760px);z-index:220}
    .ahsi__search.is-search-open:before{color:#665f55;content:"⌕";font-size:22px;left:16px;line-height:1;pointer-events:none;position:absolute;top:16px}
    .ahsi__input{background:#fff;border:1px solid rgba(255,255,255,.22);border-right:0;color:#101010;font:inherit;font-size:16px;min-height:54px;padding:0 18px;width:100%}
    .ahsi__search.is-search-open .ahsi__input{background:transparent;border:0;font-size:17px;min-height:54px;padding:0 14px 0 48px}
    .ahsi__submit{background:#c94a24;border:1px solid #c94a24;color:#fff;cursor:pointer;font:inherit;font-size:12px;font-weight:850;letter-spacing:.1em;min-height:56px;padding:0 22px;text-transform:uppercase}
    .ahsi__clear,.ahsi__close{align-items:center;background:transparent;border:0;color:#101010;cursor:pointer;display:inline-flex;font:inherit;justify-content:center;min-height:54px}
    .ahsi__clear{color:#665f55;font-size:14px;padding:0 12px}
    .ahsi__close{font-size:30px;font-weight:300;line-height:1;padding:0 14px 3px}
    .ahsi__clear[hidden],.ahsi__close[hidden],.ahsi__search.is-search-open .ahsi__submit{display:none}
    .ahsi__live{background:#fff;border:1px solid #ded2c3;box-shadow:0 18px 48px rgba(16,16,16,.24);color:#101010;grid-column:1/-1;left:0;max-height:min(620px,74vh);overflow:auto;position:absolute;right:0;top:calc(100% + 8px);z-index:210}
    .ahsi__search.is-search-open .ahsi__live{background:#f6f0e6;border-radius:0 0 10px 10px;border-top:0;display:block;left:-1px;max-height:min(620px,74vh);overflow:auto;padding:14px;position:absolute;right:-1px;top:100%;transform:none;width:auto;z-index:219}
    .ahsi__live[hidden]{display:none}
    .ahsi__live-head{align-items:center;display:flex;gap:10px;justify-content:space-between;padding-bottom:10px}
    .ahsi__live-query{font-size:13px;font-weight:850;line-height:1.25}
    .ahsi__live-count{color:#665f55;font-size:12px;font-weight:750;white-space:nowrap}
    .ahsi__group{margin-bottom:12px}
    .ahsi__group-title{align-items:center;color:#101010;display:flex;font-size:14px;font-weight:850;justify-content:space-between;line-height:1;margin-bottom:8px}
    .ahsi__products{display:grid;gap:10px;grid-template-columns:repeat(3,minmax(0,1fr))}
    .ahsi__product,.ahsi__card{background:#fff;color:inherit;text-decoration:none}
    .ahsi__product{border:1px solid #ded2c3;border-radius:10px;display:grid;gap:8px;grid-template-columns:74px minmax(0,1fr);min-height:92px;padding:8px}
    .ahsi__product-image{background:#fff;border-radius:8px;display:block;grid-row:span 2;height:74px;overflow:hidden;width:74px}
    .ahsi__product-image img{display:block;height:100%;object-fit:cover;width:100%}
    .ahsi__product-image.is-missing,.ahsi__thumb.is-missing{align-items:center;background:linear-gradient(135deg,#f6f0e6,#ded2c3);display:flex;justify-content:center}
    .ahsi__product-image.is-missing:before,.ahsi__thumb.is-missing:before{color:#665f55;content:"Image";font-size:10px;font-weight:850;letter-spacing:.12em;text-transform:uppercase}
    .ahsi__product-title,.ahsi__product-price{display:block;font-size:12px;line-height:1.16;overflow-wrap:anywhere}
    .ahsi__product-title{align-self:end;margin-top:0}
    .ahsi__product-price{align-self:start;color:#c94a24;font-weight:750;margin-top:2px}
    .ahsi__product-title{font-weight:750}
    .ahsi__product-meta,.ahsi__product-excerpt,.ahsi__product-status,.ahsi__card-detail,.ahsi__card-action{display:block;font-size:12px;line-height:1.35}
    .ahsi__product-meta,.ahsi__product-excerpt,.ahsi__product-status{display:none}
    .ahsi__card-detail{color:#665f55;margin-top:5px}
    .ahsi__cards{display:grid;gap:10px;grid-auto-flow:initial;grid-template-columns:repeat(2,minmax(0,1fr));overflow:visible;padding-bottom:2px}
    .ahsi__card{border:1px solid #ded2c3;border-radius:10px;display:grid;grid-template-columns:62px minmax(0,1fr);gap:8px;min-height:86px;padding:10px;scroll-snap-align:start}
    .ahsi__thumb{background:#fff;border-radius:8px;display:block;grid-row:span 2;height:62px;overflow:hidden;width:62px}
    .ahsi__thumb img{display:block;height:100%;object-fit:cover;width:100%}
    .ahsi__card-title{font-size:14px;font-weight:750;line-height:1.18}
    .ahsi__card-meta,.ahsi__empty{color:#665f55;font-size:14px;line-height:1.45}
    .ahsi__card-meta{grid-column:2;font-size:12px}
    .ahsi__card-detail{grid-column:2;margin-top:-2px}
    .ahsi__card-action{color:#c94a24;font-weight:850;grid-column:2;margin-top:2px}
    .ahsi__empty{padding:16px 0}
    .ahsi__footer{padding-top:4px}
    .ahsi__all{align-items:center;background:#c94a24;border-radius:999px;color:#fff;display:flex;font-size:14px;font-weight:750;justify-content:center;margin:0 auto;min-height:44px;padding:0 22px;text-decoration:none;width:fit-content}
    html.ahsi-search-lock,body.ahsi-search-lock{overflow:auto}
    @media (max-width:760px){
      .ahsi{padding:20px 0 0}
      .ahsi__intro{align-items:start;grid-template-columns:1fr;gap:12px}
      .ahsi__search:not(.is-search-open){gap:0;grid-template-columns:minmax(0,1fr) auto}
      .ahsi__search:not(.is-search-open) .ahsi__input{border:1px solid #ded2c3;border-radius:999px 0 0 999px;min-height:56px;min-width:0}
      .ahsi__search:not(.is-search-open) .ahsi__submit{border-color:#c94a24;border-radius:0 999px 999px 0;font-size:11px;min-height:56px;padding:0 15px;width:auto}
      .ahsi__inner{max-width:none;width:100%}
      .ahsi__search.is-search-open{grid-template-columns:minmax(0,1fr) auto auto;margin-bottom:10px;max-width:none;width:100%}
      .ahsi__search.is-search-open:before{font-size:22px;left:15px;top:16px}
      .ahsi__search.is-search-open .ahsi__input{font-size:17px;min-height:54px;padding-left:46px}
      .ahsi__clear,.ahsi__close{min-height:54px}
      .ahsi__clear{font-size:14px;padding:0 8px}
      .ahsi__close{font-size:30px;padding:0 12px 3px}
      .ahsi__search.is-search-open .ahsi__live{max-height:min(62vh,520px);padding:12px;position:absolute;top:100%;width:auto}
      .ahsi__products{gap:8px;grid-template-columns:1fr}
      .ahsi__product-title,.ahsi__product-price{font-size:13px}
      .ahsi__cards{grid-template-columns:1fr}
    }
  `;

  const html = `
    <section class="ahsi" data-ahsi>
      <div class="ahsi__inner">
        <div class="ahsi__intro">
          <div>
            <p class="ahsi__kicker">${labels.kicker}</p>
            <h2 class="ahsi__title">${labels.title}</h2>
          </div>
          <p class="ahsi__text">${labels.text}</p>
        </div>
        <form class="ahsi__search" action="/search" method="get" role="search" data-ahsi-search>
          <input class="ahsi__input" type="search" name="q" placeholder="${labels.placeholder}" autocomplete="off" aria-autocomplete="list" data-ahsi-input>
          <button class="ahsi__clear" type="button" hidden data-ahsi-clear>${labels.clear}</button>
          <button class="ahsi__close" type="button" aria-label="${labels.close}" hidden data-ahsi-close>×</button>
          <button class="ahsi__submit" type="submit">${labels.search}</button>
          <div class="ahsi__live" hidden data-ahsi-results></div>
        </form>
      </div>
    </section>
  `;

  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    if (document.querySelector('[data-ahsi]')) return;
    const hero = document.querySelector('.section-alpha-hero-accueil, [id*="alpha_home_hero"]');
    if (!hero) return;
    const heroContent = hero.querySelector('[class*="alpha-home-hero__content"]') || hero;

    const style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    const searchMount = hero.querySelector('[data-alpha-search-mount]') || heroContent;
    searchMount.insertAdjacentHTML('beforeend', html);

    const section = document.querySelector('[data-ahsi]');
    const form = section?.querySelector('[data-ahsi-search]');
    const input = section?.querySelector('[data-ahsi-input]');
    const results = section?.querySelector('[data-ahsi-results]');
    const clearButton = section?.querySelector('[data-ahsi-clear]');
    const closeButton = section?.querySelector('[data-ahsi-close]');
    const recentRoot = hero.querySelector('[data-ahe-recent]');
    const recentList = hero.querySelector('[data-ahe-recent-list]');
    if (!section || !form || !input || !results) return;

    const cache = new Map();
    let timer = null;
    let controller = null;
    const recentSearchesKey = 'alphaRecentHomeSearches';

    const getRecentSearches = () => {
      try {
        const items = JSON.parse(window.localStorage.getItem(recentSearchesKey) || '[]');
        return Array.isArray(items) ? items.filter(Boolean).slice(0, 7) : [];
      } catch (_error) {
        return [];
      }
    };

    const saveRecentSearch = (value) => {
      const query = String(value || '').trim();
      if (query.length < 2) return;
      const items = [query, ...getRecentSearches().filter((item) => item.toLowerCase() !== query.toLowerCase())].slice(0, 7);
      try {
        window.localStorage.setItem(recentSearchesKey, JSON.stringify(items));
      } catch (_error) {
        return;
      }
      renderRecentSearches();
    };

    const runQuery = (value) => {
      input.value = String(value || '').trim();
      saveRecentSearch(input.value);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
    };

    const renderRecentSearches = () => {
      if (!recentRoot || !recentList) return;
      const items = getRecentSearches();
      recentRoot.hidden = !items.length;
      recentList.innerHTML = items.map((item) => `<button type="button" data-ahe-recent-query="${item.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;')}">${item.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')}</button>`).join('');
      recentList.querySelectorAll('[data-ahe-recent-query]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          runQuery(button.dataset.aheRecentQuery);
        });
      });
    };

    const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[char]);

    const imageUrl = (item) => {
      const source = item?.image || item?.featured_image || '';
      const raw = typeof source === 'string' ? source : source?.url || source?.src || '';
      if (!raw) return '';
      try {
        const url = new URL(raw, window.location.origin);
        url.searchParams.set('width', '520');
        return url.toString();
      } catch (_error) {
        return raw;
      }
    };

    const normalizeTitle = (item) => (item?.title || item?.name || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();

    const uniqueByTitle = (items = []) => {
      const seen = new Set();
      return items.filter((item) => {
        const key = normalizeTitle(item);
        if (!key) return true;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    };

    const searchUrl = (query, type = '') => {
      const params = new URLSearchParams({ q: query });
      if (type) params.set('type', type);
      return `/search?${params.toString()}`;
    };

    const resourceUrl = (item) => item?.url || item?.online_store_url || '#';
    const resourcePath = (item) => {
      try {
        return new URL(resourceUrl(item), window.location.origin).pathname.replace(/\/+$/, '') || '/';
      } catch (_error) {
        return resourceUrl(item).split('?')[0].replace(/\/+$/, '');
      }
    };
    const uniqueByUrl = (items = []) => {
      const seen = new Set();
      return items.filter((item) => {
        const key = resourcePath(item);
        if (!key || key === '#') return true;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    };
    const productSearchUrl = (query) => {
      const params = new URLSearchParams({
        q: query,
        type: 'product',
        view: 'alpha-home-products',
      });
      return `/search?${params.toString()}`;
    };
    const productPrice = (product) => product?.price || product?.price_min || product?.price_max || '';
    const plainText = (value) => String(value || '')
      .replace(/<style[\s\S]*?<\/style>/gi, ' ')
      .replace(/<script[\s\S]*?<\/script>/gi, ' ')
      .replace(/<[^>]+>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    const excerpt = (value, length = 86) => {
      const text = plainText(value);
      if (!text) return '';
      return text.length > length ? `${text.slice(0, length).trim()}...` : text;
    };

    const setOpen = (shouldOpen) => {
      form.classList.toggle('is-search-open', shouldOpen);
      if (closeButton) closeButton.hidden = !shouldOpen;
      if (clearButton) clearButton.hidden = !shouldOpen || !input.value.trim();
      document.documentElement.classList.toggle('ahsi-search-lock', false);
      document.body.classList.toggle('ahsi-search-lock', false);
    };

    const closeSearch = () => {
      setOpen(false);
      results.hidden = true;
    };

    const productCard = (item) => {
      const image = imageUrl(item);
      const title = escapeHtml(item?.title || item?.name || '');
      const price = escapeHtml(productPrice(item));
      const meta = escapeHtml([item?.vendor, item?.type].filter(Boolean).slice(0, 2).join(' · '));
      const description = escapeHtml(excerpt(item?.body, 78));
      const status = item?.available === false ? labels.unavailable : labels.available;
      return `
        <a class="ahsi__product" href="${escapeHtml(resourceUrl(item))}">
          ${image ? `<span class="ahsi__product-image"><img src="${escapeHtml(image)}" alt="${title}" loading="lazy" width="520" height="650" onerror="this.parentElement.classList.add('is-missing');this.remove();"></span>` : ''}
          <span class="ahsi__product-title">${title}</span>
          ${meta ? `<span class="ahsi__product-meta">${meta}</span>` : ''}
          ${description ? `<span class="ahsi__product-excerpt">${description}</span>` : ''}
          ${price ? `<span class="ahsi__product-price">${price}</span>` : ''}
          <span class="ahsi__product-status">${status}</span>
        </a>
      `;
    };

    const resourceCard = (item, meta) => {
      const image = imageUrl(item);
      const title = escapeHtml(item?.title || item?.name || '');
      const detail = escapeHtml(excerpt(item?.body, 84));
      return `
        <a class="ahsi__card" href="${escapeHtml(resourceUrl(item))}">
          ${image ? `<span class="ahsi__thumb"><img src="${escapeHtml(image)}" alt="${title}" loading="lazy" width="148" height="108" onerror="this.parentElement.classList.add('is-missing');this.remove();"></span>` : ''}
          <span class="ahsi__card-title">${title}</span>
          <span class="ahsi__card-meta">${escapeHtml(meta)}</span>
          ${detail ? `<span class="ahsi__card-detail">${detail}</span>` : ''}
          <span class="ahsi__card-action">${document.documentElement.lang?.toLowerCase().startsWith('fr') ? 'Voir la sélection' : 'View selection'}</span>
        </a>
      `;
    };

    const group = (title, items, renderer, listClass, limit = 12) => {
      if (!items.length) return '';
      return `
        <section class="ahsi__group">
          <div class="ahsi__group-title"><span>${escapeHtml(title)}</span><span>${items.length}</span></div>
          <div class="${listClass}">${items.slice(0, limit).map(renderer).join('')}</div>
        </section>
      `;
    };

    const knownProductQueries = ['la nuit étoilée', 'sunflowers van gogh', 'mona lisa', 'water lilies monet', 'klimt kiss', 'van gogh', 'monet', 'picasso'];
    const fixedKnownProducts = [
      {
        title: 'La Nuit étoilée - Vincent van Gogh',
        url: '/products/night-starry-vincent-van-gogh',
        vendor: 'Vincent van Gogh',
        type: 'Œuvre célèbre',
        price: '299.00',
        image: 'https://cdn.shopify.com/s/files/1/0549/9656/6169/files/nuit-etoilee-f612-van-gogh.webp?v=1785251382',
      },
      {
        title: 'La Joconde - Léonard de Vinci',
        url: '/products/la-joconde-mona-lisa-leonard-de-vinci',
        vendor: 'Léonard de Vinci',
        type: 'Renaissance',
        price: '299.00',
        image: 'https://cdn.shopify.com/s/files/1/0549/9656/6169/files/mona-lisa-by-leonardo-da-vinci-042-jpg.jpg?v=1782243515',
      },
      {
        title: 'Le Baiser - Gustav Klimt',
        url: '/products/kiss-gustav-klimt',
        vendor: 'Gustav Klimt',
        type: 'Œuvre décorative',
        price: '299.00',
        image: 'https://cdn.shopify.com/s/files/1/0549/9656/6169/files/le-baiser-gustav-klimt-image-1-tableau-peint-main.jpg?v=1780659882',
      },
      {
        title: 'Nymphéas - Claude Monet',
        url: '/products/lilies-water-claude-monet-5',
        vendor: 'Claude Monet',
        type: 'Impressionnisme',
        price: '299.00',
        image: 'https://cdn.shopify.com/s/files/1/0549/9656/6169/files/nympheas-toledo-main.webp?v=1784356962',
      },
      {
        title: 'La Cène - Léonard de Vinci',
        url: '/products/supper-leonard-vinci',
        vendor: 'Léonard de Vinci',
        type: 'Art sacré',
        price: '299.00',
        image: 'https://cdn.shopify.com/s/files/1/0549/9656/6169/files/la-cene-leonard-de-vinci-image-1-tableau-peint-main.jpg?v=1780669317',
      },
      {
        title: 'Impression, Soleil levant - Claude Monet',
        url: '/products/impression-sun-rising-claude-monet',
        vendor: 'Claude Monet',
        type: 'Impressionnisme',
        price: '300.00',
        image: 'https://cdn.shopify.com/s/files/1/0549/9656/6169/files/impression-soleil-levant-claude-monet.webp?v=1785160388',
      },
      {
        title: 'La Jeune Fille à la perle - Johannes Vermeer',
        url: '/products/young-girl-pearl-johannes-vermeer',
        vendor: 'Johannes Vermeer',
        type: 'Baroque',
        price: '299.00',
        image: 'https://cdn.shopify.com/s/files/1/0549/9656/6169/files/la-jeune-fille-a-perle-johannes-vermeer-image-1-copie-peinte-main.jpg?v=1780669283',
      },
      {
        title: 'La Ronde de nuit - Rembrandt',
        url: '/products/ronde-nuit-originale-rembrandt',
        vendor: 'Rembrandt',
        type: 'Baroque',
        price: '299.00',
        image: 'https://cdn.shopify.com/s/files/1/0549/9656/6169/files/default_18f088a9-61cd-4eb5-a3ba-adf217841fb1.jpg?v=1785311459',
      },
      {
        title: 'L’École d’Athènes (d’après Raphaël) - Anton Raphael Mengs',
        url: '/products/school-athens-after-raphael-anton-mengs',
        vendor: 'Anton Raphael Mengs',
        type: 'Renaissance',
        price: '299.00',
        image: 'https://cdn.shopify.com/s/files/1/0549/9656/6169/files/l-ecole-d-athenes-apres-raphael-anton-mengs-image-1-reproduction-tableau.jpg?v=1780729748',
      },
    ];
    const fixedKnownCollections = [
      {
        title: 'Tableaux célèbres',
        url: '/collections/tableaux-celebres',
        type: 'Collection phare',
        body: 'Joconde, Nuit étoilée, Le Baiser, Le Cri et grandes icônes de la peinture.',
        image: fixedKnownProducts[1].image,
      },
      {
        title: 'Claude Monet',
        url: '/collections/claude-monet',
        type: 'Peintre célèbre',
        body: 'Nymphéas, Impression Soleil levant et paysages impressionnistes.',
        image: fixedKnownProducts[3].image,
      },
      {
        title: 'Vincent Van Gogh',
        url: '/collections/vincent-van-gogh',
        type: 'Peintre célèbre',
        body: 'Nuit étoilée, Tournesols, Iris et autoportraits peints à l’huile.',
        image: fixedKnownProducts[0].image,
      },
      {
        title: 'Gustav Klimt',
        url: '/collections/gustav-klimt',
        type: 'Peintre célèbre',
        body: 'Le Baiser, Judith, portraits dorés et compositions décoratives.',
        image: fixedKnownProducts[2].image,
      },
      {
        title: 'Léonard de Vinci',
        url: '/collections/leonard-de-vinci',
        type: 'Peintre célèbre',
        body: 'La Joconde, La Cène et chefs-d’œuvre de la Renaissance.',
        image: fixedKnownProducts[1].image,
      },
      {
        title: 'Johannes Vermeer',
        url: '/collections/johannes-vermeer',
        type: 'Peintre célèbre',
        body: 'Jeune fille à la perle, scènes intimes et lumière hollandaise.',
        image: fixedKnownProducts[6].image,
      },
      {
        title: 'Rembrandt',
        url: '/collections/rembrandt-van-rijn',
        type: 'Peintre célèbre',
        body: 'Clair-obscur, portraits et grands tableaux de la peinture hollandaise.',
        image: fixedKnownProducts[7].image,
      },
      {
        title: 'Impressionnisme',
        url: '/collections/impressionnisme',
        type: 'Style artistique',
        body: 'Monet, Renoir, Degas, paysages lumineux et touches visibles.',
        image: fixedKnownProducts[5].image,
      },
      {
        title: 'Raphaël Sanzio',
        url: '/collections/raphael-sanzio',
        type: 'Peintre célèbre',
        body: 'L’École d’Athènes, madones et chefs-d’œuvre de la Renaissance italienne.',
        image: fixedKnownProducts[8].image,
      },
    ];
    const artistIntents = [
      { aliases: ['monet', 'claude monet'], collection: '/collections/claude-monet', products: ['/products/lilies-water-claude-monet-5', '/products/impression-sun-rising-claude-monet'] },
      { aliases: ['van gogh', 'vincent van gogh'], collection: '/collections/vincent-van-gogh', products: ['/products/night-starry-vincent-van-gogh'] },
      { aliases: ['klimt', 'gustav klimt'], collection: '/collections/gustav-klimt', products: ['/products/kiss-gustav-klimt'] },
      { aliases: ['leonard de vinci', 'leonard vinci', 'vinci'], collection: '/collections/leonard-de-vinci', products: ['/products/la-joconde-mona-lisa-leonard-de-vinci', '/products/supper-leonard-vinci'] },
      { aliases: ['vermeer', 'johannes vermeer'], collection: '/collections/johannes-vermeer', products: ['/products/young-girl-pearl-johannes-vermeer'] },
      { aliases: ['rembrandt', 'rembrandt van rijn'], collection: '/collections/rembrandt-van-rijn', products: ['/products/ronde-nuit-originale-rembrandt'] },
      { aliases: ['raphael', 'raphael sanzio'], collection: '/collections/raphael-sanzio', products: ['/products/school-athens-after-raphael-anton-mengs'] },
    ];
    const normalizeQuery = (value) => String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    const applyArtistPins = (resources, query) => {
      const normalizedQuery = normalizeQuery(query);
      const intent = artistIntents.find((item) => item.aliases.includes(normalizedQuery));
      if (!intent) return resources;
      const pinnedCollection = fixedKnownCollections.filter((item) => resourcePath(item) === intent.collection);
      const pinnedProducts = fixedKnownProducts.filter((item) => intent.products.includes(resourcePath(item)));
      return {
        ...resources,
        collections: uniqueByUrl([...pinnedCollection, ...(resources.collections || [])]),
        products: uniqueByUrl([...pinnedProducts, ...(resources.products || [])]),
        artistIntent: true,
      };
    };
    const knownProductsCacheKey = 'alphaKnownSearchProducts:v2';

    const getCachedKnownProducts = () => {
      try {
        const items = JSON.parse(window.sessionStorage.getItem(knownProductsCacheKey) || '[]');
        return Array.isArray(items) && items.length ? items : fixedKnownProducts;
      } catch (_error) {
        return fixedKnownProducts;
      }
    };

    const setCachedKnownProducts = (items) => {
      try {
        window.sessionStorage.setItem(knownProductsCacheKey, JSON.stringify(items.slice(0, 12)));
      } catch (_error) {
        // Ignore unavailable session storage.
      }
    };

    const getCachedKnownCollections = () => {
      return fixedKnownCollections;
    };

    const loadKnownCollections = async () => {
      return fixedKnownCollections;
    };

    const loadKnownProducts = async () => {
      const cached = getCachedKnownProducts();
      if (cached.length) return cached;

      const responses = await Promise.all(knownProductQueries.map((query) => {
        const params = new URLSearchParams({
          q: query,
          'resources[type]': 'product',
          'resources[limit]': '7',
          'resources[limit_scope]': 'each',
          'resources[options][unavailable_products]': 'last',
        });
        return fetch(`/search/suggest.json?${params.toString()}`, {
          headers: { Accept: 'application/json' },
        })
          .then((response) => response.ok ? response.json() : null)
          .catch(() => null);
      }));

      const products = uniqueByTitle(uniqueByUrl([
        ...fixedKnownProducts,
        ...responses.flatMap((data) => data?.resources?.results?.products || []),
      ])).slice(0, 12);
      setCachedKnownProducts(products);
      return products;
    };

    const renderSuggestions = async () => {
      const cachedProducts = getCachedKnownProducts();
      const cachedCollections = getCachedKnownCollections();
      const initialHtml = [
        group(labels.knownProducts, cachedProducts, productCard, 'ahsi__products', 7),
        group(labels.knownCollections, cachedCollections, (item) => resourceCard(item, labels.collection), 'ahsi__cards', 6),
      ].join('');

      if (initialHtml) {
        results.innerHTML = initialHtml;
        results.hidden = false;
      } else {
        results.innerHTML = `<div class="ahsi__empty">${labels.loadingSuggestions}</div>`;
        results.hidden = false;
      }

      const [products, collections] = await Promise.all([
        loadKnownProducts(),
        loadKnownCollections(),
      ]);
      if (input.value.trim().length >= 2) return;

      const html = [
        group(labels.knownProducts, products, productCard, 'ahsi__products', 7),
        group(labels.knownCollections, collections, (item) => resourceCard(item, labels.collection), 'ahsi__cards', 6),
      ].join('');

      if (html) {
        results.innerHTML = html;
        results.hidden = false;
      } else {
        results.hidden = true;
        results.innerHTML = '';
      }
    };

    const render = (resources, query) => {
      if (!query || query.length < 2) {
        renderSuggestions();
        return;
      }

      const products = uniqueByUrl(resources?.products || []);
      const collections = uniqueByTitle(resources?.collections || []);
      const articles = uniqueByTitle(resources?.articles || []);
      const pages = uniqueByTitle(resources?.pages || []);
      const total = products.length + collections.length + articles.length + pages.length;

      if (!total) {
        results.innerHTML = `
          <div class="ahsi__live-head">
            <span class="ahsi__live-query">${labels.query}: ${escapeHtml(query)}</span>
            <span class="ahsi__live-count">0 ${labels.results}</span>
          </div>
          <div class="ahsi__empty">${labels.empty}</div>
          <div class="ahsi__footer"><a class="ahsi__all" href="${escapeHtml(searchUrl(query))}">${labels.all}</a></div>
        `;
        results.hidden = false;
        return;
      }

      const renderedGroups = resources?.artistIntent
        ? [
            group(labels.collections, collections, (item) => resourceCard(item, labels.collection), 'ahsi__cards', 7),
            group(labels.products, products, productCard, 'ahsi__products', 7),
            group(labels.articles, articles, (item) => resourceCard(item, labels.article), 'ahsi__cards', 7),
            group(labels.pages, pages, (item) => resourceCard(item, labels.page), 'ahsi__cards'),
          ]
        : [
            group(labels.products, products, productCard, 'ahsi__products'),
            group(labels.collections, collections, (item) => resourceCard(item, labels.collection), 'ahsi__cards', 7),
            group(labels.articles, articles, (item) => resourceCard(item, labels.article), 'ahsi__cards', 7),
            group(labels.pages, pages, (item) => resourceCard(item, labels.page), 'ahsi__cards'),
          ];

      results.innerHTML = `
        <div class="ahsi__live-head">
          <span class="ahsi__live-query">${labels.query}: ${escapeHtml(query)}</span>
          <span class="ahsi__live-count">${total} ${total > 1 ? labels.results : labels.result}</span>
        </div>
        ${renderedGroups.join('')}
        <div class="ahsi__footer"><a class="ahsi__all" href="${escapeHtml(searchUrl(query))}">${labels.all}</a></div>
      `;
      results.hidden = false;
    };

    const search = async (query) => {
      const normalized = query.trim();
      if (normalized.length < 2) {
        render({}, normalized);
        return;
      }
      if (cache.has(normalized)) {
        render(cache.get(normalized), normalized);
        return;
      }

      controller?.abort();
      controller = new AbortController();

      try {
        const params = new URLSearchParams({
          q: normalized,
          'resources[type]': 'product,collection,article,page',
          'resources[limit]': '12',
          'resources[limit_scope]': 'each',
          'resources[options][unavailable_products]': 'last',
        });
        const [response, productResponse] = await Promise.all([
          fetch(`/search/suggest.json?${params.toString()}`, {
            signal: controller.signal,
            headers: { Accept: 'application/json' },
          }),
          fetch(productSearchUrl(normalized), {
            signal: controller.signal,
            headers: { Accept: 'application/json' },
          }).catch(() => null),
        ]);
        if (!response.ok) throw new Error('Search failed');
        const data = await response.json();
        const searchResources = data?.resources?.results || {};
        const predictiveProducts = searchResources.products || [];
        if (productResponse?.ok) {
          const productData = await productResponse.json().catch(() => null);
          if (Array.isArray(productData?.products) && productData.products.length) {
            // The custom payload contains external-image URLs for products
            // intentionally created without Shopify media.
            searchResources.products = uniqueByUrl([...productData.products, ...predictiveProducts]).slice(0, 12);
          }
        }
        const rankedResources = applyArtistPins(searchResources, normalized);
        cache.set(normalized, rankedResources);
        render(rankedResources, normalized);
      } catch (error) {
        if (error.name === 'AbortError') return;
        results.hidden = true;
      }
    };

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      const query = input.value.trim();
      setOpen(true);
      if (clearButton) clearButton.hidden = !query;
      if (query.length >= 2) {
        results.innerHTML = `<div class="ahsi__empty">${labels.loading}</div>`;
        results.hidden = false;
      } else {
        renderSuggestions();
      }
      timer = window.setTimeout(() => search(input.value), 160);
    });

    input.addEventListener('focus', () => {
      setOpen(true);
      if (input.value.trim().length >= 2 && results.innerHTML.trim()) results.hidden = false;
      if (input.value.trim().length < 2) renderSuggestions();
    });

    clearButton?.addEventListener('click', () => {
      input.value = '';
      setOpen(true);
      renderSuggestions();
      input.focus();
    });

    closeButton?.addEventListener('click', closeSearch);

    form.addEventListener('submit', () => saveRecentSearch(input.value));

    results.addEventListener('click', (event) => {
      if (event.target.closest('a[href]')) saveRecentSearch(input.value);
    });

    hero.querySelectorAll('[data-ahe-query]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        runQuery(button.dataset.aheQuery);
      });
    });

    hero.querySelectorAll('[data-ahe-search-trigger]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        input.value = '';
        setOpen(true);
        renderSuggestions();
        searchMount.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeSearch();
    });

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target) && !section.contains(event.target)) closeSearch();
    });

    renderRecentSearches();
  });
})();
